import { Box, Button } from "@mui/material"
import Grid from "@mui/material/Grid2"
import React, { useEffect, useState } from "react"
import { v4 as uuidv4 } from 'uuid'
import { savePatientData, updatePatientData } from "../../services/patientServices"
import { ERROR_MESSAGE, OTHER } from "../../utils/constants"
import { CustomButton } from "../GlobalComponents/CommonComponents"
import { showToast } from "../GlobalComponents/Toast"
import ConsultantSection from "./ConsultantSection"
import GPDetailsSection from "./GPDetailsSection"
import "./index.css"
import OptometristDetailsSection from "./OptometristDetailsSection"
import {
  AddressDetailsSection,
  // ConsultantSection,
  ContactDetailsSection,
  OtherInformationSection,
  PersonalDetailsSection,
} from "./SubCardsI"

import { deleteFiles, deleteImage, uploadImages } from "../../services/fileServices"
import {
  CommentsSection,
  FileUploadSection,
  InvoicesSection,
  // GPDetailsSection,
  NextOfKinDetailsSection,
} from "./SubCardsII"

const options = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: OTHER, value: "other" },
]

const booleanOptions = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
]

const titleOptions = [
  { label: "Mr", value: "Mr" },
  { label: "Mrs", value: "Mrs" },
  { label: "Ms", value: "Ms" },
  { label: "Miss", value: "Miss" },
  { label: "Dr", value: "Dr" },
]

const consultantOptions = [
  { label: "Srinivas", value: "Srinivas" },
  { label: "Padma", value: "Padma" },
]

const gpOptions = [
  { label: "David", value: "David" },
  { label: "Rani", value: "Rani" },
]

const optometristOptions = [
  { label: "Sunny", value: "Sunny" },
  { label: "Guru", value: "Guru" },
]

function CommonUserFormData(props) {
  // const { formData } = props
  // const formFields = {
  //     firstName: "",
  //     lastName: "",
  //     email: "",
  //     gender: "",
  //     dateOfBirth: ""
  // }
  const [formData, setFormData] = useState({
    termsConditions: booleanOptions[1]?.value,
    permissionToStoreData: booleanOptions[1]?.value,
    ...props.formData
  })

  useEffect(() => {
    setFormData(props?.formData ? props.formData : {})
  }, [props?.formData, props?.formData?.invoiceDetails])

  // console.log("formDataformData123", formData, props)

  // console.log("formData 12345", formData, props)
  const [activeTab, setActiveTab] = useState(0)

  // Handle input change for the form fields
  const handleChange = (e) => {
    // console.log("eee handleChange", e.target, formData)
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const [selectedDeleteFiles, setSelectedDeleteFiles] = useState([])
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [newFiles, setNewFiles] = useState([])
  const [isUploading, setIsUploading] = useState(false)

  // Handle form submission (optional functionality)
  const handleSubmit = async (e) => {
    if (formData?.firstName?.length < 3) {
      showToast("error", "First name must be at least 3 characters long")
      return
    }

    const isEditing = props?.isEditing
    e.preventDefault()

    let currentUploadedFiles = [...uploadedFiles]

    // Check if there are new files to upload first
    if (newFiles.length > 0) {
      setIsLoading(true)
      const uploadResult = await handleFileUpload()
      if (!uploadResult || !uploadResult.success) {
        // Upload failed, don't proceed with form submission
        setIsLoading(false)
        return
      }
      // Use the updated files from the upload result
      currentUploadedFiles = uploadResult.updatedFiles
    }

    const modifiedFormData = {
      ...formData,
      patientImages: currentUploadedFiles,
      consultant: formData?.consultant?._id,
      gp: formData?.gp?._id,
      optometrist: formData?.optometrist?._id,
    }
    console.log("Form submission data:", {
      originalFormData: formData,
      currentUploadedFiles,
      modifiedFormData,
      isEditing
    })

    setIsLoading(true)
    try {
      let data = isEditing
        ? await updatePatientData({ ...modifiedFormData, id: modifiedFormData?._id })
        : await savePatientData(modifiedFormData)
      // console.log("saveUserError", data)
      if (data.error) {
        let message = data?.error?.response?.data?.message || ERROR_MESSAGE
        showToast("error", message)
      } else {

        if (selectedDeleteFiles?.length > 0) {
          for (let eachFile of selectedDeleteFiles) {
            await deleteImage(eachFile)
          }
          setSelectedDeleteFiles([])
        }

        showToast("info", isEditing ? "User Updated" : "User Saved")
        setFormData({})
        setUploadedFiles([])
        setNewFiles([])
        props?.onSubmit()
      }
    } catch (error) {
      // console.log("saveUserError", error)
      showToast("error", error.message)
    }
    setIsLoading(false)
  }

  // Function to handle file upload
  const handleFileUpload = async () => {
    if (isUploading) return false
    if (newFiles.length === 0) {
      showToast("error", "No files selected for upload")
      return false
    }

    setIsUploading(true)

    const formData = new FormData()
    newFiles?.forEach((fileObj) => {
      formData.append("files", fileObj.file)
    })

    // console.log("formData", formData, newFiles)
    const data = await uploadImages(formData)
    // console.log("uploadFiles123", data)
    if (!data?.data?.length) {
      let message = data?.message || data?.error || ERROR_MESSAGE
      showToast("error", message)
      setIsUploading(false)
      return false
    } else {
      const newData = data?.data?.map((each, index) => {
        return {
          ...newFiles[index],
          isNew: false,
          url: each.newPath,
        }
      })

      // console.log(newData, "newData123")
      const updatedUploadedFiles = [...uploadedFiles, ...newData]
      setUploadedFiles(updatedUploadedFiles)
      setNewFiles([])

      setIsUploading(false)
      return { success: true, updatedFiles: updatedUploadedFiles }
    }
  }

  // Function to handle file selection
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files)
    const existingFileNames = newFiles?.map((fileObj) => fileObj.name)
    const updatedFiles = []

    for (let file of selectedFiles) {
      if (existingFileNames.includes(file.name)) continue

      // console.log("selectedFiles123", file)
      const fileType = file.type

      let fileTypeLabel = ""
      if (fileType.startsWith("image/")) {
        fileTypeLabel = "image"
      } else if (fileType === "application/pdf") {
        fileTypeLabel = "pdf"
      } else {
        showToast("error", "Only image or PDF files are allowed!")
        return null
      }

      updatedFiles.push({
        id: uuidv4(),
        name: file.name,
        file: file,
        url: URL.createObjectURL(file),
        fileType: fileTypeLabel,
        isNew: true,
      })
    }

    setNewFiles((prevFiles) => [...prevFiles, ...updatedFiles])
    e.target.value = null;
  }

  // Function to handle file deletion
  const handleFileDelete = (id, isNew) => {
    if (isNew) {
      setNewFiles(newFiles.filter((file) => file.id !== id))
    } else {
      setUploadedFiles(uploadedFiles.filter((file) => {
        if (file.id === id) {
          setSelectedDeleteFiles(prev => [...prev, file?.url])
        }
        return file.id !== id
      }))
    }
  }

  // Initialize uploaded files from form data
  useEffect(() => {
    if (uploadedFiles.length === 0 && formData?.patientImages?.length > 0) {
      setUploadedFiles(formData?.patientImages)
    }
  }, [formData?.patientImages])

  // Wrapper function for upload button (handles different return format)
  const handleUploadButtonClick = async () => {
    const result = await handleFileUpload()
    if (result && result.success) {
      showToast("info", "Files uploaded successfully")
    }
  }

  function getErrorMsg(type, label) {
    if (type === "text") {
      return "0/30 (minimum 3 characters)"
    }
  }

  function isError(type, field) {
    if (type === "text") {
      return formData[field].length < 3
    }
  }

  const [activeModal, setActiveModal] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [searchValue, setSearchValue] = useState("")

  function handleSearchChange(e) {
    setSearchValue(e.target.value)
  }
  const onClickGPButton = () => { }



  function onCloseModal() {
    setActiveModal("")
  }

  let modalData = {
    onClose: onCloseModal,
  }

  if (activeModal === "GPModal") {
    modalData = {
      ...modalData,
      title: "GP Modal",
      show: true,
    }
  } else if (activeModal === "OptometristModal") {
    modalData = {
      ...modalData,
      title: "Optometrist Modal",
      show: true,
    }
  }

  function handleClose() {
    onCloseModal()
  }

  const [expandedSections, setExpandedSections] = useState({})

  const [areAllExpanded, setAreAllExpanded] = useState(false)

  function onClickExpand() {
    setAreAllExpanded(!areAllExpanded)
  }

  const [expandedSectionsCount, setExpandedSectionsCount] = useState(0)

  function onToggleExpand(id, isExpanded) {
    setExpandedSections({ ...expandedSections, [id]: isExpanded })
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        // border: "2px solid grey",
        alignItems: "center",
        justifyContent: "center",
        overflowY: "auto",
        // paddingTop: "20px",
        // padding: "40px 0px",
        // // width: "100%",
        // alignItems: "center",
        // // margin: "30px",
        // overflow: "auto",
        // padding: "0px 20px"
      }}
    >
      <div className="button-container">
        <Button variant="contained"
          sx={{ height: "40px" }}
          // onClick={() => {props.setModalData((prev) => ({...prev, show: false, formData: for}))}}>Back</Button>
          onClick={() => { props?.onClose() }}>Back</Button>

        {formData?.patientId && <div className="patient-id-display">
          <h1 style={{ margin: "0px" }}>Patient Id: {formData.patientId}</h1>
        </div>}
      </div>

      <div
        // className="flex-container"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          // alignItems: "center",
          // margin: "30px",
          // overflow: "auto",
          // border: "2px solid grey",
          // margin: "20px",
          // padding: "20px",
          overflow: "hidden",
        }}
      >
        <div
          className="form-section-container"
          style={
            {
              // width: "100%",
              // border: "2px solid green",
              // overflowY: "auto",
              // height: "100%",
            }
          }
        >
          <form
            className="patient-form"
            style={{
              maxWidth: "100%",
              width: "90%",
              overflowY: "auto",
              overflowX: "hidden",
              paddingRight: "15px",
              margin: "20px",
              // height: "100%"
              // border: "2px solid green"
            }}
            onSubmit={handleSubmit}
          >


            <div className="sections-container">
              <PersonalDetailsSection
                data={{
                  formData,
                  handleChange,
                  options: options,
                  titleOption: titleOptions,
                  expandedSections,
                  onToggleExpand,
                  expand: areAllExpanded,
                }}
              />

              <div className="form-children-section" style={{ width: "50%" }}>
                <ConsultantSection
                  data={{
                    formData,
                    handleChange,
                    options: consultantOptions,
                  }}
                />

                <GPDetailsSection
                  data={{
                    formData,
                    handleChange,
                    options: gpOptions,
                    activeModal,
                    setActiveModal,
                    onCloseModal,
                  }}
                />
              </div>
            </div>

            <div className="sections-container">
              <div className="form-children-section" style={{ flexGrow: 1 }}>
                <AddressDetailsSection
                  data={{
                    formData,
                    handleChange,
                    options: gpOptions,
                    activeModal,
                    setActiveModal,
                  }}
                />

                <ContactDetailsSection
                  data={{
                    formData,
                    handleChange,
                    options: gpOptions,
                    activeModal,
                    setActiveModal,
                  }}
                />
              </div>

              <div className="form-children-section" style={{ width: "50%" }}>
                <OptometristDetailsSection
                  data={{
                    formData,
                    handleChange,
                    options: optometristOptions,
                    activeModal,
                    setActiveModal,
                    onCloseModal,
                  }}
                />

                <OtherInformationSection
                  data={{
                    formData,
                    handleChange,
                    options: booleanOptions,
                    activeModal,
                    setActiveModal,
                  }}
                />
              </div>
            </div>

            <div className="sections-container">
              <NextOfKinDetailsSection
                data={{
                  formData,
                  handleChange,
                  options: gpOptions,
                  activeModal,
                  setActiveModal,
                }}
              />

              <div className="form-children-section" style={{ width: "50%" }}>
                <FileUploadSection
                  data={{
                    formData,
                    handleChange,
                    options: gpOptions,
                    activeModal,
                    setActiveModal,
                    onCloseModal,
                    setSelectedDeleteFiles,
                    uploadedFiles,
                    newFiles,
                    isUploading,
                    handleFileChange,
                    handleFileDelete,
                    handleFileUpload,
                    handleUploadButtonClick
                  }}
                />
              </div>
            </div>

            <div className="sections-container">
              <InvoicesSection
                data={{
                  formData: props?.formData,
                  handleChange,
                  options: gpOptions,
                  activeModal,
                  setActiveModal,
                }}
              />

              <div className="form-children-section" style={{
                width: "50%"
              }}>
                <CommentsSection
                  data={{
                    formData,
                    handleChange,
                    options: gpOptions,
                    activeModal,
                    setActiveModal,
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                marginTop: "20px",
              }}
            ></div>

            <Box
              sx={{
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                rowGap: "10px",
              }}
            >
              <Grid
                style={{ display: "flex", gap: "20px" }}
                fullWidth
                spacing={2}
              ></Grid>

              <Grid
                style={{ display: "flex", gap: "20px" }}
                fullWidth
                spacing={2}
              ></Grid>

              <Grid container justifyContent="center">
                <CustomButton
                  sx={{ marginX: 2, padding: "0px 20px", fontWeight: "bold" }}
                  size="large"
                  variant="outlined"
                  onClick={() => props.onClose()}
                  text="Cancel"
                />

                <CustomButton
                  size="large"
                  text={isLoading ? "Submitting..." : "Submit"}
                  onClick={handleSubmit}
                  disabled={isLoading}
                />
              </Grid>
            </Box>
          </form>
        </div>
      </div>
    </div>
  )
}

export default CommonUserFormData
